import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { TokenInterceptor } from './services/token.interceptor';

import { GraphApi } from './services/graph-api.service';
import { fromAdUser } from './reducers';
import { StoreModule } from '@ngrx/store';
import { AdUserEffects, GraphApiEffects } from './effects';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { GraphApiLoggingTransformer } from './transformers';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    AuthModule,
    EffectsModule.forFeature([AdUserEffects, GraphApiEffects]),
    StoreModule.forFeature('adUser', fromAdUser.adUserReducer),
    LoggingModule.withExtraParams([GraphApiLoggingTransformer])
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },

    GraphApi
  ]
})
export class GraphApiModule {}
